export default __webpack_public_path__ + "/dist/images/Invite.ba9e0982f06cf9903348ece29172cd12.svg";